import { Routes, Route } from "react-router-dom";
import { IntlProvider } from "react-intl";
import RootContext from "./contexts/RootContext";
import HomePage from "./HomePage";
import LoginPage from "./LoginPage";
import LogoutPage from "./LogoutPage";
import en from "./locale/en_US";
import ja from "./locale/ja_JP";
import zh from "./locale/zh_TW";
import "./styles/App.css";

const App = () => {
  const locale = navigator.language;
  let messages = en;
  if ( navigator.language.includes('zh') ) {
    messages = zh;
  } else if ( navigator.language.includes('ja') ) {
    messages = ja;
  }

  return (
    <IntlProvider locale={ locale } key={ locale } defaultLocale="en" messages={ messages }>
      <div className="App">
        <RootContext>
          <Routes>
            <Route path="/" element={ <HomePage /> } />
            <Route path="/login" element={ <LoginPage /> } />
            <Route path="/logout" element={ <LogoutPage /> } />
          </Routes>
        </RootContext>
      </div>
    </IntlProvider>
  );
};

export default App;
